$(function() {

	// 關於我們 (版型一) - 歷史沿革 輪播
	if ( $('.milestone-swiper-v1 #milestoneSwiper').length != 0 ) {
		var milestoneSwiper = new Swiper("#milestoneSwiper", {
			loop: true,
			slidesPerView: 1,
			slidesOffsetBefore: 0,
			navigation: {
				nextEl: ".milestone-wrap .swiper-button-next",
				prevEl: ".milestone-wrap .swiper-button-prev",
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					slidesOffsetBefore: 0,
				},
				641: {  // >= 641
					slidesPerView: "auto",
					slidesOffsetBefore: 60,
				},
				1281: {  // >= 1281
					slidesPerView: "auto",
					slidesOffsetBefore: 200,
				},
			},
		});
	}


});